import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    auto: { type: Boolean, default: false },
    cookie: String, // optional — if set, writes this cookie name on dismiss (7-day expiry)
  };

  connect() {
    if (this.autoValue) this.startAutoDismiss();
    // Remove before Turbo snapshots so flashes don't reappear on back nav
    this.removeBeforeCache = () => this.element.remove();
    document.addEventListener("turbo:before-cache", this.removeBeforeCache);
  }

  disconnect() {
    clearTimeout(this.timeout);
    document.removeEventListener("turbo:before-cache", this.removeBeforeCache);
  }

  startAutoDismiss() {
    this.timeout = setTimeout(() => this.fadeAndRemove(), 5000);
    this.element.addEventListener("mouseenter", this.pause);
    this.element.addEventListener("mouseleave", this.resume);
  }

  pause = () => clearTimeout(this.timeout);
  resume = () => {
    this.timeout = setTimeout(() => this.fadeAndRemove(), 2000);
  };

  dismiss() {
    if (this.hasCookieValue) {
      document.cookie = `${this.cookieValue}=1; path=/; max-age=604800; SameSite=Lax`;
    }
    this.fadeAndRemove();
  }

  fadeAndRemove() {
    clearTimeout(this.timeout);
    const el = this.element;
    el.style.maxHeight = `${el.offsetHeight}px`;
    requestAnimationFrame(() => el.classList.add("dismissing"));
    const remove = () => {
      if (el.parentNode) el.remove();
    };
    el.addEventListener("transitionend", remove, { once: true });
    setTimeout(remove, 1000); // fallback if CSS transition doesn't fire
  }
}
